import { FILE_EXTENSIONS } from "Common/Constants";
import type { TYPE_FILE_EXTENSIONS } from "Common/Types";
import { DocFilled, FolderOutlined, ImageFilled, VideoFilled } from "Icons/Icons";

export const getFileIconByExtension = (extension: TYPE_FILE_EXTENSIONS | null) => {
  switch (extension?.toLowerCase()) {
    case FILE_EXTENSIONS.PDF:
      return "PDF";
    case FILE_EXTENSIONS.JPG:
    case FILE_EXTENSIONS.JPEG:
    case FILE_EXTENSIONS.PNG:
      return <ImageFilled />;
    case FILE_EXTENSIONS.MP4:
      return <VideoFilled />;
    case FILE_EXTENSIONS.MOV:
      return <FolderOutlined />;
    default:
      return <DocFilled />;
  }
};
